// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type DispatchTaxCode,
  type DispatchTaxCodeWireFormat,
  NewDispatchTaxCode,
} from '../DispatchTaxCode/DispatchTaxCode';
import {
  type IntegrationSummary,
  type IntegrationSummaryWireFormat,
  NewIntegrationSummary,
} from '../IntegrationSummary/IntegrationSummary';

export class TaxCode {
  readonly id: string;
  readonly code: string;
  readonly name: string;
  readonly rate: string | null;
  readonly description: string | null;
  readonly externalID: string | null;
  readonly integrationSummary: IntegrationSummary | null;
  readonly dispatchTaxCodes: DispatchTaxCode[];

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.code = data.code === undefined ? '' : data.code;
    this.name = data.name === undefined ? '' : data.name;
    this.rate = data.rate === undefined ? null : data.rate;
    this.description = data.description === undefined ? null : data.description;
    this.externalID =
      // eslint-disable-next-line no-nested-ternary
      (data.externalID ?? null) === null
        ? null
        : data.externalID === undefined
          ? ''
          : data.externalID;
    this.integrationSummary =
      // eslint-disable-next-line no-nested-ternary
      (data.integration ?? data.integrationSummary ?? null) === null
        ? null
        : NewIntegrationSummary(data.integration ?? data.integrationSummary);
    this.dispatchTaxCodes = (data.dispatchTaxCodes ?? []).map((dispatchTaxCodes: any) =>
      NewDispatchTaxCode(dispatchTaxCodes),
    );
  }

  static zero(): TaxCode {
    const zeroValues: ExcludeMethodsDeep<TaxCode> = {
      id: NIL_UUID,
      code: '',
      name: '',
      rate: null,
      description: null,
      externalID: null,
      integrationSummary: null,
      dispatchTaxCodes: [],
    };
    return new TaxCode(zeroValues);
  }

  toJSON(): { [key: string]: any } {
    return {
      id: this.id,
      code: this.code,
      name: this.name,
      rate: this.rate,
      description: this.description,
      externalID: this.externalID,
      integration: this.integrationSummary,
      dispatchTaxCodes: this.dispatchTaxCodes,
    };
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type TaxCodeWireFormat = {
  id: string;
  code: string;
  name: string;
  rate: string | null;
  description: string | null;
  externalID: string | null;
  integrationSummary: IntegrationSummaryWireFormat | null;
  dispatchTaxCodes: DispatchTaxCodeWireFormat[];
};

type NewTaxCodeProps = PartialDeep<TaxCode, { recurseIntoArrays: true }>;
export const NewTaxCode: (props: NewTaxCodeProps) => TaxCode = (props) => new TaxCode(props);

type NewTaxCodeFromWireFormatProps = PartialDeep<TaxCodeWireFormat, { recurseIntoArrays: true }>;
export const NewTaxCodeFromWireFormat: (props: NewTaxCodeFromWireFormatProps) => TaxCode = (
  props,
) => new TaxCode(props);
